app.ThirdPartyOrderCellView = app.OrderCellView.extend({
  render() {
    app.CellView.prototype.render.apply(this, arguments);
    this.$('.name').addClass('text-break');
    this.$('.badge').addClass('text-wrap');
    this._renderCopyButtons(
      `${window.location.href.split('#')[0]}#third-party-orders/${this.model.id}`,
    );
    if (app.sessionUser.isBiteSupport()) {
      this._renderJsonButton();
    }
    return this;
  },
});
